import { render, staticRenderFns } from "./addorupdate-new-1.vue?vue&type=template&id=088b7ab9&scoped=true&"
import script from "./addorupdate-new-1.vue?vue&type=script&lang=js&"
export * from "./addorupdate-new-1.vue?vue&type=script&lang=js&"
import style0 from "./addorupdate-new-1.vue?vue&type=style&index=0&id=088b7ab9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b7ab9",
  null
  
)

export default component.exports